/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 1h10a2 2 0 012 2v18a2 2 0 01-2 2H11" stroke="currentColor" strokeWidth="2" />
      <path
        d="M.293 11.293a1 1 0 000 1.414l6.364 6.364a1 1 0 001.414-1.414L2.414 12l5.657-5.657A1 1 0 006.657 4.93L.293 11.293zM16 11H1v2h15v-2z"
        fill="currentColor"
      />
    </svg>
  );
});

IconComponent.displayName = 'IconLogout24';

export const IconLogout24: React.FC<ISVGIconProps> = createIcon(IconComponent);
